import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function CommentsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Comments />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Comments />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Comments />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Post match={ match } history={ history } exact /> }
            </Route>
        </Switch>
    );
}